<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal" role="dialog" aria-modal="true" aria-labelledby="add-company-title">
      <div class="modal__head">
        <div>
          <h2 id="add-company-title" class="modal__title">הוספת לוגו חדש</h2>
          <p class="modal__sub">הלוגו יופיע בעמוד הלינקטון ובמיילים לאנשי המדיה.</p>
        </div>
        <button type="button" class="modal__close" aria-label="סגירה" @click="$emit('close')">
          <LtIcon name="close" :size="18" />
        </button>
      </div>

      <div class="modal__body">
        <div class="add-company-form">
          <div class="field">
            <label class="field__label">שם חברה <span style="color: var(--c-pink-500)">*</span></label>
            <input
              v-model="form.name"
              class="input"
              placeholder="לדוגמה: Warner Music Israel"
              :disabled="saving"
              @keydown.enter.prevent="submit"
            />
          </div>

          <!-- <div class="field">
            <label class="field__label">לינק <span class="opt">אופציונלי</span></label>
            <input
              v-model="form.url"
              class="input"
              placeholder="https://..."
              type="url"
              :disabled="saving"
            />
          </div> -->

          <div class="field">
            <label class="field__label">תמונת לוגו <span class="opt">אופציונלי</span></label>
            <Dropzone
              title="העלאת לוגו"
              hint="PNG, JPG או GIF — רקע שקוף מומלץ"
              accept="jpg,jpeg,gif,png"
              :value="form.logo"
              @update:value="form.logo = $event"
            />
          </div>
        </div>
      </div>

      <div class="modal__foot modal__foot--end">
        <button type="button" class="btn btn--ghost" :disabled="saving" @click="$emit('close')">ביטול</button>
        <button
          type="button"
          class="btn btn--primary"
          :disabled="!form.name.trim() || saving"
          @click="submit"
        >
          {{ saving ? 'שומר...' : 'הוספה' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import Dropzone from './Dropzone.vue';

export default {
  name: 'AddCompanyModal',
  components: { LtIcon, Dropzone },
  emits: ['close', 'created'],
  data() {
    return {
      saving: false,
      form: {
        name: '',
        url: '',
        logo: null,
      },
    };
  },
  methods: {
    submit() {
      if (!this.form.name.trim() || this.saving) return;
      this.saving = true;
      this.api(
        {
          action: 'my_linktones/company_create',
          data: {
            name: this.form.name.trim(),
            url: this.form.url.trim() || null,
            logo: this.form.logo ? this.form.logo.storage_id : null,
          },
        },
        (res) => {
          this.saving = false;
          const company = res && res.data ? res.data : res;
          if (company && company.error) {
            this.alert(company.error);
            return;
          }
          this.$emit('created', company);
        },
        () => {
          this.saving = false;
          this.alert('אירעה שגיאה, נסה שנית.');
        },
      );
    },
  },
};
</script>
